<template>
  <div class="inline-block relative h-[36px]">
    <input
      v-model="model"
      v-mask="'##'"
      type="text"
      class="rounded-[5px] bg-white h-full w-[59px] text-[18px] text-blue font-bold leading-[normal] px-[13px] py-[6px] border border-grey-pale outline-0"
      @input="handleNumber"
    />
    <div
      class="flex flex-col absolute right-[13px] top-[50%] translate-y-[-50%]"
    >
      <InlineSvg
        src="/assets/svg/icons/prev.svg"
        class="rotate-90 cursor-pointer"
        @click="handleNumber('plus')"
      />
      <InlineSvg
        src="/assets/svg/icons/next.svg"
        class="rotate-90 cursor-pointer"
        @click="handleNumber('minus')"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
});

const model = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    model.value = newVal;
  }
);

const handleNumber = (sign = '') => {
  if (sign == 'plus') model.value = parseInt(model.value) + 1;
  if (sign == 'minus') model.value = parseInt(model.value) - 1;

  if (model.value > 99) model.value = 99;
  if (model.value < 1) model.value = 1;

  emit('update:modelValue', parseInt(model.value));
};
</script>
